import {
  initialState,
  Actions,
  State,
  GET_ALL_CALENDARS,
  GET_ALL_CALENDARS_SUCCESS,
  GET_ALL_CALENDARS_ERROR,
  RESET_GET_ALL_CALENDARS,
} from "../../types/calendar/getAll";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_CALENDARS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_CALENDARS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_CALENDARS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ALL_CALENDARS:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
